import { render, staticRenderFns } from "./choosecompany.vue?vue&type=template&id=ab25d0d6&scoped=true"
import script from "./choosecompany.vue?vue&type=script&lang=js"
export * from "./choosecompany.vue?vue&type=script&lang=js"
import style0 from "./choosecompany.vue?vue&type=style&index=0&id=ab25d0d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab25d0d6",
  null
  
)

export default component.exports